import Rest from '../../Rest'
import { serialize } from 'object-to-formdata'
import { isArray, isObject } from 'lodash'
import mapValues from 'lodash/mapValues'

export default class RequestFormIncidentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v2/forms/'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  formatFormData(formData: any) {
    return mapValues(formData, (data, key) => {
      if (isArray(data) && data.length > 0 && isObject(data[0]) && 'files' in data[0]) {
        return data.map(
          (list) => list.files.map((fileObj) => fileObj.file)
        )
      }

      if (isObject(data) && 'files' in data) {
        return (data as any).files.map((fileObj) => fileObj.file)
      }

      return data
    })
  }

  submit(hash: String, formData: any) {
    const data = this.formatFormData(formData)

    // console.debug('debug data', Object.fromEntries(serialize(formData, {indices: true, nullsAsUndefineds: true})))

    return this.post(`/${hash}`, serialize(data, {indices: true, nullsAsUndefineds: true}))
  }

  validate(hash: String, formData) {
    const data = this.formatFormData(formData)
    return this.post(`/${hash}/validation`, serialize(data, {indices: true, nullsAsUndefineds: true}))
  }

  getFormDefinition(hash: String) {
    return this.get(`/${hash}`)
  }
}
